import script from "./RightPie.vue?vue&type=script&setup=true&lang=js"
export * from "./RightPie.vue?vue&type=script&setup=true&lang=js"

export default script